/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

function useOutsideClick<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T>,
  handler: (event: MouseEvent) => void,
): void {
  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent): void => {
      const element = ref?.current;

      if (element && !element.contains(event.target as Node)) {
        handler(event);
      }
    };

    window?.document?.addEventListener('mousedown', handleOutsideClick);

    return (): void => {
      window?.document?.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);
}

export { useOutsideClick };
